import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";

export const footer = (theme: Theme) => css`
  width: 100%;
  background: ${theme.surface.level1};
  flex-shrink: 0;
  margin-top: 1rem;
  z-index: ${layers.indexModal};
`;

export const topBorder = (theme: Theme) => css`
  border-top: 1px solid ${theme.separator.base};
`;

export const mobileWrapper = css`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 32px;
`;

export const wrapper = css`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;

  @media (max-width: ${dimensions.tabletMax}) {
    flex-direction: column;
    padding: 0;
  }
`;
